<app-buy-sell-menu>
    <mat-card class="mat-elevation-z0">
        <mat-card-title class="header">
            <h5 appLocalizationPopupDirective localizationCode="BuySellPlanEditor">{{ 'BuySellPlanEditor' | translate: {Default: "Buy/Sell Plan Editor"} }}</h5>

            <div>
                <mat-chip-list *ngIf="buySellPlan">
                    <mat-chip 
                        [ngClass]="{
                            'red-chip': buySellPlan.status?.id === 'VALIDATIONFAILED' || buySellPlan.status?.id === 'FAILED' || buySellPlan.status?.id === 'COMPLETEDWITHERRORS'  ,
                            'green-chip': buySellPlan.status?.id === 'PUBLISHED',
                            'orange-chip': buySellPlan.status?.id === 'QUEUED',
                            'blue-chip': buySellPlan.status?.id === 'PUBLISHING'
                        }"
                    >{{ buySellPlan.status?.name }}</mat-chip>
                </mat-chip-list>

                <button mat-stroked-button setColor="primaryColour" color="primary" appLocalizationPopupDirective localizationCode="BackToBuySellPlans" appPreventDoubleClick (throttledClick)="backToBuySellPlans()">
                    <mat-icon class="material-icons-outlined">arrow_back</mat-icon>
                    {{ 'BackToBuySellPlans' | translate: {Default: "Back to Buy/Sell Plans"} }}
                </button>

                <button mat-stroked-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="refresh()">
                    <mat-icon class="material-icons-outlined">refresh</mat-icon>
                    {{ 'Refresh' | translate: {Default: "Refresh"} }}
                </button>

                <button mat-stroked-button setColor="primaryColour" *ngIf="buySellPlan?.status?.id !== 'DRAFT'" color="primary" appPreventDoubleClick (throttledClick)="openPublishHistoryDialog()">
                    <mat-icon class="material-icons-outlined">history</mat-icon>
                    {{ 'PublishHistory' | translate: {Default: "Publish History"} }}
                </button>

                <button mat-stroked-button setColor="primaryColour" *ngIf="buySellPlan?.status?.id === 'DRAFT' || buySellPlan?.status?.id === 'PUBLISHED'" color="primary" appPreventDoubleClick (throttledClick)="openConfirmPublishDialog()">
                    <mat-icon class="material-icons-outlined">publish</mat-icon>
                    {{ 'Publish' | translate: {Default: "Publish"} }}
                </button>

                <button mat-raised-button setColor="primaryColour" [disabled]="!planFormValid" color="primary" appPreventDoubleClick (throttledClick)="save()">
                    {{ 'Save' | translate: {Default: "Save"} }}
                </button>
            </div>
        </mat-card-title>
        <mat-card-content>
            <div class="left">
                <app-form-generator 
                    *ngIf="!loading && formId"
                    [formId]="formId"
                    [formData]="formData"
                    (emitFormData)="formDataEmitted($event)"
                    (emitFormDataChange)="formDataEmitted($event)"
                    (emitFormPristine)="formPristineEmitted($event)"
                    (emitFormStatus)="formStatusUpdated($event)"
                ></app-form-generator>
            </div>
            <div class="right">
                <app-buy-sell-plan-employees
                    *ngIf="!loading && buySellPlan?.id"
                    [buySellPlanId]="buySellPlan?.id"
                ></app-buy-sell-plan-employees>

                <app-buy-sell-plan-reviewers
                    *ngIf="!loading && buySellPlan?.id"
                    [buySellPlanId]="buySellPlan?.id"
                ></app-buy-sell-plan-reviewers>
            </div>
        </mat-card-content>
    </mat-card>
</app-buy-sell-menu>